import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMemberTicketPayments, createMemberTicketPayment } from './api';
import { memberTicketPaymentKeys } from './keys';
import { CreateMemberTicketPaymentBody } from './types';

export const useMemberTicketPayments = ({ centerId, params, enabled = true }: { centerId: string; params?: Record<string, string>; enabled?: boolean }) =>
    useQuery({
        queryKey: [...memberTicketPaymentKeys.list(centerId), params],
        queryFn: () => getMemberTicketPayments(centerId, params),
        enabled: enabled && !!centerId,
        select: (data) => data?.data ?? null,
    });

export const useCreateMemberTicketPayment = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ centerId, body }: { centerId: string; body: CreateMemberTicketPaymentBody }) => createMemberTicketPayment(centerId, body),
        onSuccess: (_, v) => { qc.invalidateQueries({ queryKey: memberTicketPaymentKeys.list(v.centerId) }); },
    });
};
